import { ContentfulImage } from '@stadionhq-v3/contentful-ui';
import {
  CleanContentful,
  CleanedContentfulImageProps,
} from '@stadionhq-v3/clean-contentful';
import { ImageLink } from '@graphql/__generated__/graphql';
import { HeaderSponsorProps } from '@components/organisms/site-nav/siteNav.types';
import { Translations } from '@lib/dictionary-keys/__generated__';

const headerSponsorTransform = (
  imageLink: CleanContentful<ImageLink> | undefined,
  sponsoredByLabel: Translations['common']['label']['sponsoredBy']
): HeaderSponsorProps | undefined => {
  if (!imageLink?.image) return undefined;

  return {
    title: sponsoredByLabel,
    image: (
      <ContentfulImage {...(imageLink.image as CleanedContentfulImageProps)} />
    ),
    imagePosition: 'right',
    onDark: true,
    url: imageLink.link?.url ?? undefined,
    target: imageLink.link?.target ?? undefined,
  };
};

export default headerSponsorTransform;
